import React from 'react'
import UsersPanel from './UsersPanel'

const UsersTab = ({ admin: { roles, users } }) => (
  <div className='role-view'>
    <div className='children-view'>
      <UsersPanel users={users} roles={roles} />
    </div>
  </div>
)

export default UsersTab
